import { Button, Table, Text, Title } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

import { RouteList } from '@/shared/constants';
import { useProjectPath } from '@/shared/projects/project-path';

import {
  useGetPublisher,
  useGetPublisherBooks,
} from '../model/publisher-detail-page.cases';
import styles from './publisher-detail-page.module.scss';

export const PublisherDetailPage = () => {
  const navigate = useNavigate();
  const withProject = useProjectPath();
  const getPublisherQuery = useGetPublisher();
  const getPublisherBooksQuery = useGetPublisherBooks();

  function goToEditPublisher() {
    const publisherId = getPublisherQuery.data?.id;

    if (publisherId) {
      navigate(withProject(RouteList.EDIT_PUBLISHER(String(publisherId))));
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div>
          <Title order={1} size={44} className={styles.title}>
            {getPublisherQuery.data?.title}
          </Title>
          {getPublisherQuery.data?.description && (
            <Text className={styles.description}>
              {getPublisherQuery.data.description}
            </Text>
          )}
          <Button
            variant="outline"
            className={styles.editButton}
            onClick={goToEditPublisher}
          >
            Редактировать издательство
          </Button>
        </div>
        {getPublisherQuery.data?.imgUrl && (
          <img
            src={getPublisherQuery.data.imgUrl}
            alt="preview"
            className={styles.preview}
          />
        )}
      </div>

      <div className={styles.books}>
        <p className={styles.booksTitle}>Список книг</p>
        <Table withTableBorder flex={1}>
          <Table.Thead>
            <Table.Tr>
              <Table.Th className={styles.tableHeadCell}>Обложка</Table.Th>
              <Table.Th className={styles.tableHeadCell}>Название</Table.Th>
              <Table.Th className={styles.tableHeadCell}>Автор</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {getPublisherBooksQuery.data?.books?.map((book) => (
              <Table.Tr
                key={book.id}
                className={styles.tableRow}
                onClick={() =>
                  navigate(
                    withProject(RouteList.BOOK_DETAILS(book.id.toString())),
                  )
                }
              >
                <Table.Td width="20%">
                  <img
                    src={book.imgUrl}
                    alt="preview"
                    className={styles.tableBookPreview}
                  />
                </Table.Td>
                <Table.Td className={styles.tableBookName} width="50%">
                  {book.title}
                </Table.Td>
                <Table.Td className={styles.tableBookAuthorName} width="30%">
                  {book.author}
                </Table.Td>
              </Table.Tr>
            )) || []}
          </Table.Tbody>
        </Table>
        {/* <Button variant="outline" onClick={() => navigate(RouteList.BOOKS)}>
          Открыть полный список
        </Button> */}
      </div>
    </div>
  );
};
